<template>
  <v-container class="pa-0">
    <div class="caption grey--text">
      {{ label }}
    </div>
    <div :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'">
      {{ value }}
    </div>
  </v-container>
</template>
<script>
export default {
  name: 'LabelField',
  props: {
    label: {
      type: String,
      default: '#'
    },
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
